import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { AuthService, HTTP_ERRORS, ToastrService } from '@mapfre-tech/amap3';

/*
 * Interceptor that handles calls to the back and answers
 */
export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const toastService = inject(ToastrService);
  const translateService = inject(TranslateService);

  return next(req).pipe(
    catchError((err: any) => {
      if (_.get(err, 'status') === 401) {
        authService.logout();
      } else if (_.get(err, 'status') === 409) {
        toastService.add({
          severity: 'warn',
          summary: translateService.instant('DUPLICATED.SUMMARY'),
          detail: translateService.instant('DUPLICATED.DETAIL'),
          life: 5000
        });
      } else if (_.includes(_.get(err, 'url'), 'exported-') && _.get(err, 'status') === 0) {
        console.log('API Gateway timeout 504', err);
      } else {
        if (!req.url.includes('translations') && _.get(err, 'status') !== 403) {
          if (req.url.includes('i18n')) {
            translateService.currentLang = 'en';
          } else {
            const currentLanguage = translateService.currentLang;
            const error = HTTP_ERRORS[currentLanguage]?.[err.status]
              ?? HTTP_ERRORS.en?.[err.status]
              ?? 'ERROR';
            toastService.add({ severity: 'error', summary: 'ERROR', detail: error, life: 5000 });
          }
        }
      }
      return throwError(() => err);
    })
  );
};
